const state = {
    // 当前"告警中"的记录数量，>0 时企业后台顶部展示全局告警横幅
    activeCount: 0,
    // 最紧急（最先出现）的一条告警中记录，供横幅展示
    activeAlarm: null,
    // 全局 WS 推送的完整"正在越界设备"列表（sn/deviceName/alarmId/alarmState/alarmTime/currentDistance），供列表页按行匹配实时距离
    activeAlarms: []
}

const mutations = {
    setState(state, payload) {
        state[payload.key] = payload.value
    },
}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
